import type { Asset } from '../../../../packages/sdk/src/index';

export const candidates=[{id:'anthropic',name:'Anthropic',symbol:'ANTH',tag:'Frontier AI research',description:'Frontier AI research for a safer tomorrow.'},{id:'openai',name:'OpenAI',symbol:'OPEN',tag:'Artificial intelligence',description:'Advancing human potential through AI.'},{id:'figure',name:'Figure AI',symbol:'FIGR',tag:'Humanoid robotics',description:'General-purpose humanoid robotics.'},{id:'neuralink',name:'Neuralink',symbol:'NEUR',tag:'Brain computer interfaces',description:'Brain-computer interfaces for a more capable tomorrow.'},{id:'anduril',name:'Anduril',symbol:'ANDR',tag:'Defense technology',description:'Autonomous defense and national security systems.'}];

export type Candidate = typeof candidates[number];

// Catalog identity is separate from asset approval and route availability.
export function companyForAsset(asset?: Pick<Asset, 'symbol'>) {
  return asset ? candidates.find(company => asset.symbol === 'w' + company.symbol) : undefined;
}
export function configuredAsset(company: Candidate, assets: readonly Asset[] = []) {
  return assets.find(asset => asset.symbol === 'w' + company.symbol);
}
export function resolveAsset(key: string | undefined, assets: readonly Asset[] = []) {
  const company = candidates.find(company => company.id === key);
  const asset = company ? configuredAsset(company, assets) : assets.find(asset => asset.id === key);
  return { company: company ?? companyForAsset(asset), asset };
}
export function assetContext(path: string, company: Candidate) {
  return path + '?candidate=' + encodeURIComponent(company.id);
}
